import './index.css'

import * as React from 'react'
import { createRoot } from 'react-dom/client'

import { ThemeProvider } from '@/components/ThemeProvider'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { installErrorCapture } from '@/lib/error-capture'
import { ErrorBoundary } from '@/modules/errors/ErrorBoundary'

import { App } from './App'

// Antes de tudo: erro de qualquer lugar entra no buffer que vai no chamado.
installErrorCapture()

// SÓ DEV — `?simular-erro=boot`: carrega um módulo que não existe e não monta
// o React, como quando o bundle não baixa. Cai na tela de falha de partida do
// index.html (depois da recarga automática). O build de produção corta isto.
if (import.meta.env.DEV && new URLSearchParams(window.location.search).get('simular-erro') === 'boot') {
  const missing = document.createElement('script')
  missing.type = 'module'
  missing.src = '/src/simulado-falha-de-boot.tsx'
  document.body.appendChild(missing)
} else {
  start()
}

function start() {
  // Módulos ligaram: daqui em diante quem cuida é o ErrorBoundary, não a guarda do index.html.
  ;(window as Window & { __supplyBooted?: boolean }).__supplyBooted = true

  const DevErrorTrigger = import.meta.env.DEV ? React.lazy(() => import('@/modules/errors/DevErrorTrigger')) : null

  const root = document.getElementById('root')
  if (!root) throw new Error('#root ausente no index.html')

  createRoot(root).render(
    <React.StrictMode>
      {/* Por fora de tema, sessão e router: pega até o que derruba o shell. */}
      <ErrorBoundary variant="tela-cheia">
        <ThemeProvider>
          <TooltipProvider delayDuration={300}>
            <App />
            {DevErrorTrigger && (
              <React.Suspense fallback={null}>
                <DevErrorTrigger scope="raiz" />
              </React.Suspense>
            )}
            <Toaster richColors closeButton position="top-right" />
          </TooltipProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  )
}
